import Combine from './Combine/Combine';

import request from '../../Helpers/Request';

class Profiles {
    constructor(settings) {
        this.settings = settings;

        this.combine = new Combine(this.settings);
    }

    index() {
        return new Promise((resolve, reject) => {
            request('GET', '/profiles/resellers', this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    show(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/profiles/resellers/${id}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    destroy(id) {
        return new Promise((resolve, reject) => {
            request('DELETE', `/profiles/resellers/${id}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Profiles;
